import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const RawFileDigitalAssetSchema = withDefaults({
  type: 'raw-file-digital-asset',
  traits: ['digital-asset'],
  fields: [
    {
      kind: 'attribute',
      name: 'externalUrl',
    },
    {
      kind: 'belongsTo',
      name: 'fileHistory',
      type: 'file-history',
      options: {
        async: false,
        inverse: 'rawFileDigitalAsset',
      },
    },
  ],
});

export default RawFileDigitalAssetSchema;
